(function () {
  const logic = window.WifiCandyOrderAheadLogic;

  if (!logic) {
    return;
  }

  const STEPS = ['dates', 'pickup', 'return'];

  const RESERVE_BRIDGE_FAILSAFE_MS = 15 * 60 * 1000;
  const ORDER_AHEAD_CART_HINT_KEY = 'wificandy_order_ahead_hint';
  const RESERVE_ADD_FAILURE_MESSAGE = 'Unable to prepare your reservation. Please try again.';
  const PICKUP_DATE_DETAIL_KEYS = [
    'startDate',
    'start_date',
    'dateStart',
    'date_start',
    'pickupDate',
    'pickup_date',
    'deliveryDate',
    'delivery_date',
    'fromDate',
    'dateFrom',
    'checkIn',
    'checkin',
    'start',
    'from'
  ];
  const PICKUP_DATE_DETAIL_SCOPES = ['data', 'payload', 'rental', 'booking', 'selection'];
  const PICKUP_START_FIELD_SELECTORS = [
    'input[name*="date_start" i]',
    'input[id*="date_start" i]',
    'input[name*="start" i]',
    'input[id*="start" i]',
    'input[name*="from" i]',
    'input[id*="from" i]',
    'input[name*="pickup" i]',
    'input[id*="pickup" i]',
    'input[name*="delivery" i]',
    'input[id*="delivery" i]',
    'input[name*="debut" i]',
    'input[id*="debut" i]',
    'input[placeholder*="start" i]',
    'input[placeholder*="pickup" i]',
    'input[placeholder*="delivery" i]',
    'input[aria-label*="start" i]',
    'input[aria-label*="pickup" i]',
    'input[aria-label*="delivery" i]',
    'input[type="date"]'
  ];
  const BRIDGE_DEBUG_ENABLED = Boolean(
    window.WIFICANDY_ORDER_AHEAD_DEBUG || (window.Shopify && window.Shopify.designMode)
  );

  function safeParse(json, fallback) {
    try {
      return JSON.parse(json);
    } catch (_error) {
      return fallback;
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseRuleMap(value) {
    if (typeof value === 'string') {
      return safeParse(value, {});
    }
    return value && typeof value === 'object' ? value : {};
  }

  function getOptionContentMap(kind, content, suffix) {
    const prefix = kind === 'pickup' ? 'pickup' : 'return';
    return content[`${prefix}${suffix}`] || {};
  }

  function getOptionTitle(kind, item, content = {}) {
    return getOptionContentMap(kind, content, 'Titles')[item.key] || item.title || '';
  }

  function getOptionSubtitle(kind, item, content = {}) {
    return getOptionContentMap(kind, content, 'Subtitles')[item.key] || '';
  }

  function formatMoney(cents, currencyCode) {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency: currencyCode || 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  }

  function buildOptionRow(kind, item, selected, currencyCode, content = {}, options = {}) {
    const pickupBadges = content.pickupBadges || {};
    const title = getOptionTitle(kind, item, content);
    const subtitle = getOptionSubtitle(kind, item, content);
    const priceMarkup = Number(item.priceCents) === 0
      ? '<span class="row-pill-free">Free</span>'
      : `<span class="row-price">${escapeHtml(formatMoney(item.priceCents, currencyCode))}</span>`;
    const disabled = Boolean(options.disabled);
    const badge = kind === 'pickup' ? pickupBadges[item.key] : null;
    const badgeMarkup = badge
      ? `<span class="row-badge row-badge--${escapeHtml(badge.kind)}">${escapeHtml(badge.label)}</span>`
      : '';
    const availabilityLabel = options.availabilityLabel ? String(options.availabilityLabel) : '';
    const availabilityBadgeMarkup = availabilityLabel
      ? `<span class="row-badge row-badge--leadtime">${escapeHtml(availabilityLabel)}</span>`
      : '';
    const subtitleMarkup = subtitle
      ? `<span class="row-sub">${escapeHtml(subtitle)}</span>`
      : '';

    return `
      <label class="fulfill-row" data-order-ahead-option data-kind="${kind}" data-key="${escapeHtml(item.key)}" data-selected="${selected ? 'true' : 'false'}" data-disabled="${disabled ? 'true' : 'false'}"${badge ? ' data-badge="' + escapeHtml(badge.kind) + '"' : ''}>
        <input type="radio" name="${kind}-selection" value="${escapeHtml(item.key)}" ${selected ? 'checked' : ''} ${disabled ? 'disabled' : ''}>
        <span class="fulfill-radio"></span>
        <span class="row-label">
          <span class="row-title">
            <span class="row-title-text">${escapeHtml(title)}</span>
            ${badgeMarkup}
            ${availabilityBadgeMarkup}
            ${priceMarkup}
          </span>
          ${subtitleMarkup}
        </span>
      </label>
    `;
  }

  function sortByOrder(items, order) {
    const byKey = new Map(items.map((item) => [item.key, item]));
    return order.map((key) => byKey.get(key)).filter(Boolean);
  }

  function prefersReducedMotion() {
    if (typeof window.matchMedia !== 'function') {
      return false;
    }
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobileViewport() {
    if (typeof window.matchMedia !== 'function') {
      return false;
    }
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function initOrderAhead(root) {
    const configNode = root.querySelector('[data-order-ahead-config]');

    if (!configNode) {
      return;
    }

    const config = safeParse(configNode.textContent, null);

    if (!config) {
      return;
    }

    const currencyCode = 'EUR';
    const pickupVariants = sortByOrder(config.pickupService.variants || [], config.rules.pickupOrder || []);
    const returnVariants = sortByOrder(config.returnService.variants || [], config.rules.returnOrder || []);

    if (!pickupVariants.length || !returnVariants.length) {
      return;
    }

    const pickupByKey = new Map(pickupVariants.map((item) => [item.key, item]));
    const returnByKey = new Map(returnVariants.map((item) => [item.key, item]));
    const defaultReturnMap = parseRuleMap(config.rules.defaultReturnMap);
    const optionContent = {
      pickupTitles: parseRuleMap(config.rules.pickupTitles),
      pickupSubtitles: parseRuleMap(config.rules.pickupSubtitles),
      returnSubtitles: parseRuleMap(config.rules.returnSubtitles),
      pickupBadges: parseRuleMap(config.rules.pickupBadges)
    };
    const powercandy = {
      productId: Number((config.powercandy && config.powercandy.productId) || 0) || null,
      variantId: Number((config.powercandy && config.powercandy.variantId) || 0) || null,
      priceCents: Number((config.powercandy && config.powercandy.priceCents) || 0) || 0
    };
    const nativeAddToCartButton = root.querySelector('.oa-native-form [data-add-to-cart]')
      || root.querySelector('.order-ahead-card__native-form [data-add-to-cart]');
    const nativeProductForm = root.querySelector('.oa-native-form form')
      || (nativeAddToCartButton && typeof nativeAddToCartButton.closest === 'function'
        ? nativeAddToCartButton.closest('form')
        : null);

    const state = {
      activeBundleKey: '',
      activeStep: 'dates',
      addonSelected: false,
      attentionStep: '',
      hasUserSelectedStep: false,
      historyRestoredSinceLastReserve: false,
      pickupKey: '',
      pendingRedirectUntil: 0,
      quantity: 1,
      reserveError: '',
      reserveBridgeArmed: false,
      rentalCents: 0,
      rentalLabel: '',
      rentalStartDate: null,
      returnKey: ''
    };

    let recapObserver = null;
    let observedRecapNode = null;
    let reserveWindowTimeoutId = null;
    let pendingDatesResetTimeoutId = null;
    let hasRenderedSummary = false;
    let lastHadSelectedDates = false;
    let lastHadSelectedPickup = false;
    let lastHadSelectedReturn = false;
    let cartPreflightPending = false;

    const logisticsRoot = root.querySelector('[data-order-ahead-logistics]');
    const stepLis = {};
    const stepHeads = {};
    const stepBodies = {};
    STEPS.forEach((step) => {
      stepLis[step] = root.querySelector(`[data-order-ahead-step-li="${step}"]`);
      stepHeads[step] = root.querySelector(`[data-order-ahead-step-head="${step}"]`);
      if (stepLis[step]) {
        stepBodies[step] = stepLis[step].querySelector('.oa-step__body');
      }
    });

    const datesValue = root.querySelector('[data-order-ahead-dates-value]');
    const datesMeta = root.querySelector('[data-order-ahead-dates-meta]');
    const datesStage = root.querySelector('.oa-dates-stage');
    const returnGroup = root.querySelector('[data-order-ahead-group="return"]');
    const pickupSummary = root.querySelector('[data-pickup-summary]');
    const returnSummary = root.querySelector('[data-return-summary]');
    const logisticsHint = root.querySelector('[data-order-ahead-logistics-hint]');
    const pickupChip = root.querySelector('[data-order-ahead-pickup-chip]');
    const returnChip = root.querySelector('[data-order-ahead-return-chip]');
    const pickupList = root.querySelector('[data-order-ahead-pickup-list]');
    const returnList = root.querySelector('[data-order-ahead-return-list]');
    const returnNote = root.querySelector('[data-order-ahead-return-note]');
    const addonCheckbox = root.querySelector('[data-order-ahead-powercandy]');
    const addonCard = addonCheckbox ? addonCheckbox.closest('.oa-upsell__card') : null;
    const addonPrice = root.querySelector('[data-order-ahead-powercandy-price]');
    const addonRow = root.querySelector('[data-order-ahead-addon-row]');
    const addonTotal = root.querySelector('[data-order-ahead-addon-total]');
    const rentalTotal = root.querySelector('[data-order-ahead-rental-total]');
    const pickupTotal = root.querySelector('[data-order-ahead-pickup-total]');
    const returnTotal = root.querySelector('[data-order-ahead-return-total]');
    const grandTotal = root.querySelector('[data-order-ahead-grand-total]');
    const summaryMeta = root.querySelector('[data-order-ahead-summary-meta]');
    const reserveButton = root.querySelector('[data-order-ahead-reserve]');
    const reserveStatus = root.querySelector('[data-order-ahead-status]');
    const floorBar = root.querySelector('[data-order-ahead-floor]');
    const floorTotal = root.querySelector('[data-order-ahead-floor-total]');
    const floorMeta = root.querySelector('[data-order-ahead-floor-meta]');
    const floorReserve = root.querySelector('[data-order-ahead-floor-reserve]');

    if (
      !stepLis.dates || !stepLis.pickup || !stepLis.return ||
      !stepHeads.dates || !stepHeads.pickup || !stepHeads.return ||
      !pickupSummary || !returnSummary ||
      !pickupChip || !returnChip ||
      !pickupList || !returnList || !returnNote ||
      !rentalTotal || !pickupTotal || !returnTotal || !grandTotal ||
      !summaryMeta || !reserveButton
    ) {
      return;
    }

    if (nativeAddToCartButton) {
      nativeAddToCartButton.tabIndex = -1;
      nativeAddToCartButton.setAttribute('aria-hidden', 'true');
    }

    if (!window.__wifiCandyOrderAheadBaseFetch && typeof window.fetch === 'function') {
      window.__wifiCandyOrderAheadBaseFetch = window.fetch.bind(window);
    }

    function pushDataLayer(eventName, extra) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(
        Object.assign({ event: eventName }, extra || {})
      );
    }

    function bridgeLog(step, payload) {
      if (!BRIDGE_DEBUG_ENABLED) {
        return;
      }

      if (payload === undefined) {
        console.log('[bridge]', step);
        return;
      }

      console.log('[bridge]', step, payload);
    }

    function isNativeAddToCartReady() {
      if (!nativeAddToCartButton) {
        return false;
      }

      if (nativeAddToCartButton.disabled) {
        return false;
      }

      if (typeof nativeAddToCartButton.getAttribute === 'function') {
        const ariaDisabled = nativeAddToCartButton.getAttribute('aria-disabled');
        if (ariaDisabled === 'true') {
          return false;
        }
      }

      return true;
    }

    function requestIzyRentRefresh(reason) {
      bridgeLog('izyrent_refresh_requested', {
        reason: reason || 'manual'
      });

      try {
        if (typeof window.CustomEvent === 'function') {
          document.dispatchEvent(new window.CustomEvent('izyrentRefresh', {
            detail: { reason: reason || 'manual' }
          }));
          return;
        }
      } catch (_error) {
        // Fall through to the basic event path below.
      }

      try {
        if (typeof window.Event === 'function') {
          document.dispatchEvent(new window.Event('izyrentRefresh'));
        }
      } catch (_error) {
        // Best-effort only.
      }
    }

    function getInternalCartFetch(fallbackFetch) {
      if (typeof window.__wifiCandyOrderAheadBaseFetch === 'function') {
        return window.__wifiCandyOrderAheadBaseFetch;
      }

      return fallbackFetch;
    }

    async function parseJsonResponseBody(response) {
      if (!response || typeof response.clone !== 'function') {
        return null;
      }

      try {
        return JSON.parse(await response.clone().text());
      } catch (_error) {
        return null;
      }
    }

    function resolveRequestMeta(input) {
      if (typeof input === 'string') {
        return { requestUrl: logic.extractRequestUrl(input), via: 'string' };
      }
      if (input && typeof input.url === 'string') {
        return { requestUrl: logic.extractRequestUrl(input), via: 'Request.url' };
      }
      if (input && typeof input.href === 'string') {
        return { requestUrl: logic.extractRequestUrl(input), via: 'URL.href' };
      }
      return { requestUrl: logic.extractRequestUrl(input), via: 'String(input)' };
    }

    function isArmedIzyRentPreparationRequest(requestUrl) {
      if (!state.reserveBridgeArmed) {
        return false;
      }

      const normalizedUrl = String(requestUrl || '');

      if (!normalizedUrl.includes('izyrent') || normalizedUrl.includes('wificandy_supplemental')) {
        return false;
      }

      return (
        normalizedUrl.includes('/cart.js') ||
        normalizedUrl.includes('/cart/update.js')
      );
    }

    function updateSelectionAttributes(container, selectedKey) {
      container.querySelectorAll('[data-order-ahead-option]').forEach((row) => {
        const selected = row.dataset.key === selectedKey;
        row.dataset.selected = selected ? 'true' : 'false';
        const input = row.querySelector('input');
        if (input) {
          input.checked = selected;
        }
      });
    }

    function getPickupVariant() {
      return pickupByKey.get(state.pickupKey) || null;
    }

    function getReturnVariant() {
      return returnByKey.get(state.returnKey) || null;
    }

    function getAddonCents() {
      if (!powercandy.variantId || !state.addonSelected) {
        return 0;
      }
      return Number(powercandy.priceCents || 0);
    }

    function parseOptionalQuantity(value) {
      const raw = String(value ?? '').trim();
      if (!raw) {
        return null;
      }

      const parsed = Number.parseInt(raw, 10);
      if (!Number.isFinite(parsed) || parsed < 1) {
        return null;
      }

      return parsed;
    }

    function normalizeQuantity(value) {
      return parseOptionalQuantity(value) || 1;
    }

    function readIzyRentQuantityFromDom() {
      if (!datesStage) {
        return null;
      }

      const quantityInputs = datesStage.querySelectorAll('.izyMultiInput');
      for (const input of quantityInputs) {
        const quantity = parseOptionalQuantity(input && typeof input.value === 'string' ? input.value : '');
        if (quantity) {
          return quantity;
        }
      }

      return null;
    }

    function syncQuantityFromIzyRent(detail) {
      const quantity = parseOptionalQuantity(
        detail && (detail.multiQty ?? detail.multiqty ?? detail.quantity)
      ) || readIzyRentQuantityFromDom() || state.quantity || 1;

      state.quantity = normalizeQuantity(quantity);
      return state.quantity;
    }

    function deriveRentalCentsFromEvent(detail, quantity) {
      const checkoutCents = logic.parseMoneyTextToCents(detail && detail.totalCheckout ? detail.totalCheckout : '');
      if (checkoutCents > 0) {
        return checkoutCents;
      }

      const unitPriceCents = Number(detail && detail.price) || 0;
      if (unitPriceCents > 0) {
        return unitPriceCents * quantity;
      }

      const unitTotalCents = logic.parseMoneyTextToCents(detail && detail.total ? detail.total : '');
      if (unitTotalCents > 0) {
        return unitTotalCents * quantity;
      }

      return 0;
    }

    function getStepBaseState(step) {
      const hasDates = logic.hasSelectedRentalDates(state.rentalLabel);
      const hasPickup = Boolean(state.pickupKey);
      const hasReturn = Boolean(state.returnKey);

      if (step === 'dates') {
        return hasDates ? 'done' : 'available';
      }
      if (step === 'pickup') {
        if (!hasDates) return 'locked';
        return hasPickup ? 'done' : 'available';
      }
      if (step === 'return') {
        if (!hasDates || !hasPickup) return 'locked';
        return hasReturn ? 'done' : 'available';
      }
      return 'available';
    }

    function isStepAccessible(step) {
      return getStepBaseState(step) !== 'locked';
    }

    function setActiveStep(step, opts = {}) {
      if (!STEPS.includes(step)) {
        return;
      }
      if (!isStepAccessible(step)) {
        return;
      }
      state.activeStep = step;
      state.hasUserSelectedStep = true;

      if (logisticsRoot) {
        logisticsRoot.dataset.step = step;
      }

      applyStepStates();

      if (opts.scrollAfterExpand && stepLis[step]) {
        scheduleScrollAfterExpand(stepLis[step]);
      } else if (opts.scrollIntoView && stepLis[step]) {
        scrollStepIntoView(stepLis[step]);
      }

      if (opts.focusFirstInput) {
        focusFirstInputInStep(step);
      }
    }

    function scheduleScrollAfterExpand(li) {
      window.requestAnimationFrame(() => {
        window.setTimeout(() => {
          scrollStepIntoView(li);
        }, 320);
      });
    }

    function applyStepStates() {
      STEPS.forEach((step) => {
        const baseState = getStepBaseState(step);
        const isActive = step === state.activeStep;
        let visualState;

        if (baseState === 'locked') {
          visualState = 'locked';
        } else if (isActive) {
          visualState = 'active';
        } else if (baseState === 'done') {
          visualState = 'done';
        } else {
          visualState = 'available';
        }

        const li = stepLis[step];
        const head = stepHeads[step];

        if (li) {
          li.dataset.stepState = visualState;
        }
        if (head) {
          const isLocked = visualState === 'locked';
          head.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          head.disabled = isLocked;
          head.dataset.disabled = isLocked ? 'true' : 'false';
        }
      });
    }

    function focusFirstInputInStep(step) {
      const body = stepBodies[step];
      if (!body) return;
      const candidate = body.querySelector(
        'input:not([type="hidden"]):not([disabled]), button:not([disabled]):not([data-add-to-cart]), [tabindex]:not([tabindex="-1"])'
      );
      if (candidate && typeof candidate.focus === 'function') {
        try {
          candidate.focus({ preventScroll: true });
        } catch (_error) {
          candidate.focus();
        }
      }
    }

    function scrollStepIntoView(li) {
      if (!li || typeof li.getBoundingClientRect !== 'function') return;
      const rect = li.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const fitsInViewport = rect.height <= viewportHeight - 48;
      const fullyVisible = rect.top >= 0 && rect.bottom <= viewportHeight;
      if (fitsInViewport && fullyVisible) return;
      const headEl = li.querySelector('.oa-step__head');
      const headRect = headEl && typeof headEl.getBoundingClientRect === 'function'
        ? headEl.getBoundingClientRect()
        : rect;
      const headVisible = headRect.top >= 0 && headRect.bottom <= viewportHeight;
      if (!fitsInViewport && headVisible) return;
      const block = fitsInViewport ? 'nearest' : 'start';
      const behavior = prefersReducedMotion() ? 'auto' : 'smooth';
      try {
        li.scrollIntoView({ behavior, block });
      } catch (_error) {
        li.scrollIntoView();
      }
    }

    function setAttentionStep(step) {
      state.attentionStep = step || '';
      STEPS.forEach((s) => {
        const li = stepLis[s];
        if (!li) return;
        if (state.attentionStep === s) {
          li.dataset.attention = 'true';
        } else {
          delete li.dataset.attention;
        }
      });
    }

    function syncLoadingState(button, isLoading) {
      if (!button) {
        return;
      }

      if (isLoading) {
        button.dataset.loading = 'true';
        button.setAttribute('aria-busy', 'true');
        return;
      }

      delete button.dataset.loading;
      button.removeAttribute('aria-busy');
    }

    function resolveAddonConfigFromProduct(product) {
      if (typeof logic.buildCatalogProductAddonConfig === 'function') {
        return logic.buildCatalogProductAddonConfig(product);
      }
      const variants = Array.isArray(product && product.variants) ? product.variants : [];
      const variant = variants.find((item) => item && item.available) || variants[0] || null;
      return {
        productId: Number(product && product.id) || null,
        variantId: variant ? Number(variant.id) || null : null,
        priceCents: variant ? Number(variant.price) || 0 : 0
      };
    }

    function syncAddonUi() {
      if (addonPrice) {
        addonPrice.textContent = powercandy.variantId
          ? formatMoney(powercandy.priceCents, currencyCode)
          : '';
      }
      if (addonCard) {
        addonCard.dataset.checked = state.addonSelected ? 'true' : 'false';
      }
    }

    async function ensurePowercandyConfig() {
      if (powercandy.variantId) {
        return powercandy;
      }
      const handles = ['powercandy', 'powercandy-kit'];
      for (const handle of handles) {
        try {
          const response = await window.fetch(`/products/${handle}.js`);
          if (!response.ok) continue;
          const product = await response.json();
          const resolved = resolveAddonConfigFromProduct(product);
          if (resolved.variantId) {
            powercandy.productId = resolved.productId;
            powercandy.variantId = resolved.variantId;
            powercandy.priceCents = resolved.priceCents;
            bridgeLog('powercandy_hydrated', {
              handle,
              productId: powercandy.productId,
              variantId: powercandy.variantId,
              priceCents: powercandy.priceCents
            });
            syncAddonUi();
            renderSummary();
            return powercandy;
          }
        } catch (error) {
          bridgeLog('powercandy_hydration_error', {
            handle,
            message: error && error.message ? error.message : 'unknown_error'
          });
        }
      }
      bridgeLog('powercandy_hydration_unavailable');
      syncAddonUi();
      return powercandy;
    }

    function updateReserveState() {
      const hasCompleteSelection = logic.isReservationReady({
        rentalLabel: state.rentalLabel,
        rentalCents: state.rentalCents,
        pickupKey: state.pickupKey,
        returnKey: state.returnKey
      });
      const nativeAddPending = !state.reserveBridgeArmed &&
        hasCompleteSelection &&
        !isNativeAddToCartReady();
      const isReady = hasCompleteSelection && !nativeAddPending;
      const isResolving = nativeAddPending || (
        !isReady &&
        logic.hasSelectedRentalDates(state.rentalLabel) &&
        logic.hasSelectedLogistics({ pickupKey: state.pickupKey, returnKey: state.returnKey })
      );
      const totalLabel = grandTotal.textContent || formatMoney(state.rentalCents, currencyCode);
      const statusMessage = logic.getReserveStatusMessage({
        rentalLabel: state.rentalLabel,
        pickupKey: state.pickupKey,
        returnKey: state.returnKey,
        isResolving,
        isProcessing: state.reserveBridgeArmed,
        errorMessage: state.reserveError
      });
      const buttonState = state.reserveBridgeArmed
        ? 'pending'
        : (isResolving ? 'resolving' : (state.reserveError ? 'error' : (isReady ? 'ready' : 'invalid')));
      const buttonLabel = logic.getReserveButtonLabel({
        totalLabel,
        isProcessing: state.reserveBridgeArmed,
        isReady,
        isResolving,
        rentalLabel: state.rentalLabel,
        pickupKey: state.pickupKey,
        returnKey: state.returnKey
      });

      reserveButton.disabled = state.reserveBridgeArmed || isResolving;
      if (reserveButton.disabled) {
        reserveButton.setAttribute('aria-disabled', 'true');
      } else {
        reserveButton.removeAttribute('aria-disabled');
      }
      reserveButton.dataset.state = buttonState;
      reserveButton.textContent = buttonLabel;
      syncLoadingState(reserveButton, state.reserveBridgeArmed);

      if (reserveStatus) {
        reserveStatus.textContent = statusMessage;
        reserveStatus.dataset.state = buttonState;
      }

      if (floorBar) {
        floorBar.dataset.state = buttonState;
      }
      if (floorTotal) {
        floorTotal.textContent = isReady ? totalLabel : '€—';
        floorTotal.dataset.state = isReady ? 'ready' : 'placeholder';
      }
      if (floorMeta) {
        floorMeta.textContent = floorMetaText({
          isReady,
          isResolving,
          buttonState
        });
      }
      if (floorReserve) {
        floorReserve.disabled = reserveButton.disabled;
        floorReserve.dataset.state = buttonState;
        floorReserve.textContent = floorReserveLabel({
          isReady,
          isResolving,
          isProcessing: state.reserveBridgeArmed,
          totalLabel
        });
        syncLoadingState(floorReserve, state.reserveBridgeArmed);
        if (floorReserve.disabled) {
          floorReserve.setAttribute('aria-disabled', 'true');
        } else {
          floorReserve.removeAttribute('aria-disabled');
        }
      }
    }

    function floorMetaText({ isReady, isResolving, buttonState }) {
      if (buttonState === 'pending') return '';
      if (isResolving) return 'Confirming total';
      if (isReady) return 'All set — review &amp; reserve';
      if (!logic.hasSelectedRentalDates(state.rentalLabel)) return 'Pick dates to see total';
      if (!state.pickupKey) return 'Choose pickup / delivery next';
      if (!state.returnKey) return 'Choose return next';
      return 'Pick dates to see total';
    }

    function floorReserveLabel({ isReady, isResolving, isProcessing, totalLabel }) {
      if (isProcessing) return 'Preparing...';
      if (isResolving) return 'Confirming';
      if (isReady) return `Reserve · ${totalLabel}`;
      if (!logic.hasSelectedRentalDates(state.rentalLabel)) return 'Choose dates';
      if (!state.pickupKey) return 'Choose pickup / delivery';
      if (!state.returnKey) return 'Choose return';
      return 'Reserve';
    }

    function disarmReserveBridge() {
      state.reserveBridgeArmed = false;
      state.pendingRedirectUntil = 0;
      updateReserveState();

      if (reserveWindowTimeoutId) {
        window.clearTimeout(reserveWindowTimeoutId);
        reserveWindowTimeoutId = null;
      }
    }

    function armReserveBridge() {
      const failsafeUntil = Date.now() + RESERVE_BRIDGE_FAILSAFE_MS;
      state.reserveBridgeArmed = true;
      state.pendingRedirectUntil = failsafeUntil;
      updateReserveState();

      if (reserveWindowTimeoutId) {
        window.clearTimeout(reserveWindowTimeoutId);
      }
      reserveWindowTimeoutId = window.setTimeout(() => {
        if (state.reserveBridgeArmed && state.pendingRedirectUntil === failsafeUntil) {
          bridgeLog('reserve_window_timeout', {
            armed: state.reserveBridgeArmed,
            now: Date.now(),
            pendingRedirectUntil: state.pendingRedirectUntil
          });
          disarmReserveBridge();
        }
      }, RESERVE_BRIDGE_FAILSAFE_MS + 200);
    }

    function syncRentalStateFromRecapMarkup(markup) {
      const recap = logic.extractIzyRecapState(markup);
      const quantity = syncQuantityFromIzyRent();
      state.reserveError = '';
      state.rentalCents = recap.rentalCents * quantity;
      state.rentalLabel = recap.rentalLabel;
    }

    function parseRentalStartDateCandidate(value) {
      return typeof logic.parseDateInput === 'function'
        ? logic.parseDateInput(value)
        : null;
    }

    function getScopedDetailObjects(detail) {
      const scopes = [detail];
      PICKUP_DATE_DETAIL_SCOPES.forEach((key) => {
        if (detail && typeof detail[key] === 'object' && detail[key]) {
          scopes.push(detail[key]);
        }
      });
      return scopes;
    }

    function syncRentalStartDateFromDetail(detail) {
      const scopes = getScopedDetailObjects(detail);
      for (const scope of scopes) {
        for (const key of PICKUP_DATE_DETAIL_KEYS) {
          const parsed = parseRentalStartDateCandidate(scope && scope[key]);
          if (parsed) {
            state.rentalStartDate = parsed;
            return parsed;
          }
        }
      }
      return null;
    }

    function fieldDescriptor(node) {
      if (!node) return '';
      return [
        node.name,
        node.id,
        node.placeholder,
        typeof node.getAttribute === 'function' ? node.getAttribute('aria-label') : '',
        typeof node.getAttribute === 'function' ? node.getAttribute('data-label') : ''
      ].join(' ');
    }

    function isLikelyEndDateField(node) {
      return /end|return|drop.?off|checkout|date_end|to\b|fin/i.test(fieldDescriptor(node));
    }

    function readDateValueFromField(node) {
      if (!node) return null;
      const candidates = [
        typeof node.value === 'string' ? node.value : '',
        typeof node.getAttribute === 'function' ? node.getAttribute('value') : '',
        node.dataset ? node.dataset.value : '',
        node.dataset ? node.dataset.date : '',
        node.dataset ? node.dataset.startDate : '',
        typeof node.textContent === 'string' ? node.textContent : ''
      ];

      for (const candidate of candidates) {
        const parsed = parseRentalStartDateCandidate(candidate);
        if (parsed) {
          return parsed;
        }
      }

      return null;
    }

    function syncRentalStartDateFromDom() {
      if (!datesStage) {
        return null;
      }

      for (const selector of PICKUP_START_FIELD_SELECTORS) {
        const nodes = datesStage.querySelectorAll(selector);
        for (const node of nodes) {
          if (isLikelyEndDateField(node)) {
            continue;
          }
          const parsed = readDateValueFromField(node);
          if (parsed) {
            state.rentalStartDate = parsed;
            return parsed;
          }
        }
      }

      return null;
    }

    function cancelPendingDatesReset() {
      if (!pendingDatesResetTimeoutId) {
        return;
      }
      window.clearTimeout(pendingDatesResetTimeoutId);
      pendingDatesResetTimeoutId = null;
    }

    function clearPickupAndReturnSelections() {
      if (!state.pickupKey && !state.returnKey) {
        return false;
      }

      state.pickupKey = '';
      state.returnKey = '';
      return true;
    }

    function scheduleLogisticsResetIfDatesStayEmpty() {
      cancelPendingDatesReset();
      pendingDatesResetTimeoutId = window.setTimeout(() => {
        syncRentalStartDateFromDom();
        syncRentalStateFromRecapNode();

        if (logic.hasSelectedRentalDates(state.rentalLabel)) {
          return;
        }

        state.rentalStartDate = null;
        if (clearPickupAndReturnSelections()) {
          setAttentionStep('dates');
          renderOptions();
          renderSummary();
        }
      }, 180);
    }

    function syncPickupSelectionsToCurrentDates() {
      if (!logic.hasSelectedRentalDates(state.rentalLabel) || !state.pickupKey || !state.rentalStartDate) {
        return false;
      }

      const availability = logic.getPickupAvailability({
        pickupKey: state.pickupKey,
        rentalStartDate: state.rentalStartDate,
        now: new Date()
      });

      if (availability.isAvailable) {
        return false;
      }

      const changed = clearPickupAndReturnSelections();
      if (!changed) {
        return false;
      }

      setAttentionStep('pickup');
      setActiveStep('pickup', { scrollAfterExpand: true });
      return true;
    }

    function syncRentalStateFromEvent(event) {
      const detail = event && event.detail ? event.detail : {};
      const quantity = syncQuantityFromIzyRent(detail);
      const centsFromEvent = deriveRentalCentsFromEvent(detail, quantity);
      state.reserveError = '';
      state.rentalCents = centsFromEvent;
      syncRentalStartDateFromDetail(detail);
    }

    function syncRentalStateFromRecapNode() {
      const recapNode = root.querySelector('#izyRecap');
      if (!recapNode) return false;
      syncRentalStateFromRecapMarkup(recapNode.innerHTML);
      syncRentalStartDateFromDom();
      return true;
    }

    function maybeAutoAdvance(prev) {
      // Only handles transitions driven indirectly via the IzyRent recap observer:
      // first-time dates selection → open Pickup. Pickup and return selections
      // are handled explicitly in their change handlers so re-selection works.
      const hasDates = logic.hasSelectedRentalDates(state.rentalLabel);
      const hasPickup = Boolean(state.pickupKey);

      if (!prev.hadDates && hasDates && !hasPickup) {
        setActiveStep('pickup', { scrollAfterExpand: true });
      }
    }

    function closeReturnPanel() {
      if (state.activeStep === 'return') {
        state.activeStep = '';
        applyStepStates();
      }
      scrollFocusToSummaryOnMobile();
    }

    function scrollFocusToSummaryOnMobile() {
      if (!isMobileViewport()) return;
      const target = root.querySelector('.oa-upsell') || root.querySelector('.oa-summary');
      if (!target || typeof target.scrollIntoView !== 'function') return;
      window.requestAnimationFrame(() => {
        window.setTimeout(() => {
          const behavior = prefersReducedMotion() ? 'auto' : 'smooth';
          try {
            target.scrollIntoView({ behavior, block: 'start' });
          } catch (_error) {
            target.scrollIntoView();
          }
        }, 320);
      });
    }

    function renderSummary() {
      const prev = {
        hadDates: lastHadSelectedDates,
        hadPickup: lastHadSelectedPickup,
        hadReturn: lastHadSelectedReturn
      };

      const pickup = getPickupVariant();
      const returnOption = getReturnVariant();
      const hasDates = logic.hasSelectedRentalDates(state.rentalLabel);
      const hasPickup = Boolean(pickup);
      const hasReturn = Boolean(returnOption);
      const isReady = logic.isReservationReady({
        rentalLabel: state.rentalLabel,
        rentalCents: state.rentalCents,
        pickupKey: state.pickupKey,
        returnKey: state.returnKey
      });
      const shouldShowPlaceholderTotal = logic.shouldShowPlaceholderTotal({
        rentalLabel: state.rentalLabel,
        rentalCents: state.rentalCents,
        pickupKey: state.pickupKey,
        returnKey: state.returnKey
      });
      const addonCents = getAddonCents();
      const summary = logic.buildCheckoutSummary({
        rentalCents: state.rentalCents,
        pickupCents: Number((pickup && pickup.priceCents) || 0),
        returnCents: Number((returnOption && returnOption.priceCents) || 0),
        addonCents
      });
      const logisticsState = logic.getLogisticsState({
        pickupKey: state.pickupKey,
        returnKey: state.returnKey
      });

      lastHadSelectedDates = hasDates;
      lastHadSelectedPickup = hasPickup;
      lastHadSelectedReturn = hasReturn;
      hasRenderedSummary = true;

      if (state.attentionStep && getStepBaseState(state.attentionStep) === 'done') {
        setAttentionStep('');
      }

      if (datesValue) {
        datesValue.textContent = hasDates ? state.rentalLabel : 'Choose dates';
      }
      if (datesMeta) {
        if (!hasDates) {
          datesMeta.textContent = 'Start with your travel window';
        } else if (state.rentalStartDate && typeof logic.getBusinessDaysUntil === 'function') {
          const workingDays = logic.getBusinessDaysUntil(state.rentalStartDate, new Date());
          datesMeta.textContent = `${workingDays} working day${workingDays === 1 ? '' : 's'} until pickup`;
        } else if (!hasPickup) {
          datesMeta.textContent = 'Travel window saved · pickup next';
        } else if (!hasReturn) {
          datesMeta.textContent = 'Travel window saved';
        } else {
          datesMeta.textContent = 'Travel window confirmed';
        }
      }

      pickupSummary.textContent = hasPickup
        ? `${pickup.title} · ${Number(pickup.priceCents) === 0 ? 'Free' : formatMoney(pickup.priceCents, currencyCode)}`
        : 'Choose your pickup / delivery option';
      returnSummary.textContent = hasReturn
        ? `${returnOption.title} · ${Number(returnOption.priceCents) === 0 ? 'Free' : formatMoney(returnOption.priceCents, currencyCode)}`
        : 'Choose your return option';

      rentalTotal.textContent = isReady ? formatMoney(summary.rentalCents, currencyCode) : '—';
      rentalTotal.dataset.state = isReady ? 'ready' : 'placeholder';
      pickupTotal.textContent = isReady
        ? (Number(summary.pickupCents) === 0 ? 'Free' : formatMoney(summary.pickupCents, currencyCode))
        : 'Choose';
      pickupTotal.dataset.state = isReady ? 'ready' : 'placeholder';
      returnTotal.textContent = isReady
        ? (Number(summary.returnCents) === 0 ? 'Free' : formatMoney(summary.returnCents, currencyCode))
        : 'Choose';
      returnTotal.dataset.state = isReady ? 'ready' : 'placeholder';
      grandTotal.textContent = shouldShowPlaceholderTotal
        ? '€—'
        : formatMoney(summary.totalCents, currencyCode);
      grandTotal.classList.toggle('is-placeholder', shouldShowPlaceholderTotal);
      summaryMeta.textContent = logic.getSummaryMetaText({
        rentalLabel: state.rentalLabel,
        rentalCents: state.rentalCents,
        pickupKey: state.pickupKey,
        returnKey: state.returnKey,
        readyText: summaryMeta.dataset.defaultText || ''
      });
      if (addonRow && addonTotal) {
        addonRow.hidden = !isReady || addonCents <= 0;
        addonTotal.textContent = !isReady || addonCents <= 0 ? '' : formatMoney(addonCents, currencyCode);
      }

      if (logisticsRoot) {
        logisticsRoot.dataset.state = logisticsState;
      }

      if (pickupChip) {
        pickupChip.textContent = hasPickup ? 'Pickup / delivery set' : (hasDates ? 'Pickup / delivery required' : 'Pick dates first');
        pickupChip.dataset.state = hasPickup ? 'ready' : 'pending';
      }

      if (returnChip) {
        returnChip.textContent = hasReturn ? 'Return set' : (hasPickup ? 'Return required' : 'Pick pickup first');
        returnChip.dataset.state = hasReturn ? 'ready' : 'pending';
      }

      if (logisticsHint) {
        logisticsHint.textContent = logic.getLogisticsProgressText({
          pickupKey: state.pickupKey,
          returnKey: state.returnKey
        });
      }

      if (returnGroup) {
        returnGroup.dataset.disabled = hasPickup ? 'false' : 'true';
      }

      updateSelectionAttributes(pickupList, state.pickupKey);
      updateSelectionAttributes(returnList, state.returnKey);

      if (!hasPickup) {
        returnNote.textContent = 'Choose your pickup / delivery option first, then confirm your return option.';
      } else if (!hasReturn) {
        const suggestedReturnKey = logic.getDefaultReturn(state.pickupKey, defaultReturnMap);
        const suggestedReturn = returnByKey.get(suggestedReturnKey);
        returnNote.textContent = suggestedReturn
          ? `Recommended return: ${suggestedReturn.title}.`
          : 'Choose your return option to continue.';
      } else {
        returnNote.textContent = config.rules.helperCopy[state.pickupKey]
          || config.rules.helperCopy.default
          || '';
      }

      applyStepStates();

      if (hasRenderedSummary) {
        maybeAutoAdvance(prev);
      }

      updateReserveState();
    }

    function renderOptions() {
      const hasDates = logic.hasSelectedRentalDates(state.rentalLabel);
      const availabilityNow = new Date();

      pickupList.innerHTML = pickupVariants
        .map((item) => {
          const availability = logic.getPickupAvailability({
            pickupKey: item.key,
            rentalStartDate: state.rentalStartDate,
            now: availabilityNow
          });
          const disabled = hasDates && !availability.isAvailable;
          return buildOptionRow('pickup', item, item.key === state.pickupKey, currencyCode, optionContent, {
            disabled,
            availabilityLabel: disabled && availability.leadDays > 0
              ? `Needs ${availability.leadDays}+ days`
              : ''
          });
        })
        .join('');

      returnList.innerHTML = returnVariants
        .map((item) => buildOptionRow(
          'return',
          item,
          item.key === state.returnKey,
          currencyCode,
          optionContent,
          { disabled: !state.pickupKey }
        ))
        .join('');
    }

    async function getCartSnapshot(originalFetch) {
      const response = await originalFetch('/cart.js');
      if (!response.ok) {
        throw new Error('cart_snapshot_failed');
      }
      return response.json();
    }

    async function clearCart(originalFetch) {
      const response = await originalFetch('/cart/clear.js', { method: 'POST' });
      if (!response.ok) {
        throw new Error('cart_clear_failed');
      }
    }

    async function ensureEmptyCartOrPrompt(originalFetch) {
      const cart = await getCartSnapshot(originalFetch);
      if (!Array.isArray(cart.items) || cart.items.length === 0) {
        return true;
      }
      const shouldClear = typeof window.confirm === 'function' && window.confirm(
        'Your cart already contains items. Select OK to empty it, or Cancel to keep your items and add this WiFi reservation.'
      );
      if (shouldClear) {
        await clearCart(originalFetch);
      }
      return true;
    }

    function isMatchingRentalLine(item) {
      const productId = Number(item && (item.product_id || item.product && item.product.id) || 0);
      const variantId = Number(item && (item.variant_id || item.id) || 0);

      return (
        productId === Number(config.product.id) ||
        variantId === Number(config.product.variantId)
      );
    }

    function setOrderAheadCartHint(active) {
      try {
        if (active) {
          window.sessionStorage.setItem(ORDER_AHEAD_CART_HINT_KEY, '1');
        } else {
          window.sessionStorage.removeItem(ORDER_AHEAD_CART_HINT_KEY);
        }
      } catch (_error) {
        // Session storage is a best-effort cart hint only.
      }
    }

    function handleIzyRentAddFailure(details) {
      disarmReserveBridge();
      setOrderAheadCartHint(false);
      state.reserveError = RESERVE_ADD_FAILURE_MESSAGE;
      updateReserveState();
      bridgeLog('izyrent_add_failed', details);
      pushDataLayer('order_ahead_izyrent_add_failed', details || {});
    }

    function resolveAddedRentalLine(addResponseBody) {
      if (!addResponseBody || typeof addResponseBody !== 'object') {
        return null;
      }

      const directMatch = isMatchingRentalLine(addResponseBody) ? addResponseBody : null;
      if (directMatch && directMatch.key) {
        return directMatch;
      }

      if (!Array.isArray(addResponseBody.items)) {
        return null;
      }

      const matchingItems = addResponseBody.items.filter((item) => item && item.key && isMatchingRentalLine(item));
      return matchingItems.length ? matchingItems[matchingItems.length - 1] : null;
    }

    async function tagRentalCartLine(originalFetch, bundleKey, addResponseBody) {
      let rentalLine = resolveAddedRentalLine(addResponseBody);

      if (!rentalLine || !rentalLine.key) {
        const cart = await getCartSnapshot(originalFetch);
        const cartItems = cart.items || [];
        const rentalCandidates = cartItems.filter(isMatchingRentalLine);
        rentalLine = rentalCandidates[rentalCandidates.length - 1];
      }

      if (!rentalLine || !rentalLine.key) {
        bridgeLog('rental_tag_skipped', {
          bundleKey,
          reason: 'rental_line_not_found'
        });
        return null;
      }

      const properties = Object.assign({}, rentalLine.properties || {}, {
        __wificandyBundleKey: bundleKey,
        __wificandyBundleRole: 'rental',
        __wificandyParentUrl: config.product.url
      });

      bridgeLog('rental_tag_request', { bundleKey, lineKey: rentalLine.key });

      const tagResponse = await originalFetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: rentalLine.key,
          quantity: rentalLine.quantity,
          properties
        })
      });

      bridgeLog('rental_tag_response', {
        bundleKey,
        ok: tagResponse.ok,
        status: tagResponse.status
      });

      if (!tagResponse.ok) {
        return null;
      }

      return rentalLine.key;
    }

    async function appendSupplementalItems(originalFetch, addResponseBody) {
      state.addonSelected = Boolean(addonCheckbox && addonCheckbox.checked);
      const bundleKey = state.activeBundleKey || `bundle_${Date.now()}`;
      const pickupVariant = getPickupVariant();
      const returnVariant = getReturnVariant();
      let taggedRentalLineKey = null;
      const supplementalItems = logic.buildSupplementalItems({
        bundleKey,
        pickupVariantId: pickupVariant.id,
        returnVariantId: returnVariant.id,
        powercandyVariantId: state.addonSelected ? powercandy.variantId : null,
        parentProductUrl: config.product.url
      });

      bridgeLog('supplemental_prepare', {
        pickupKey: state.pickupKey,
        returnKey: state.returnKey,
        addonSelected: state.addonSelected,
        powercandyVariantId: state.addonSelected ? powercandy.variantId : null,
        supplementalItems
      });

      let lastError = null;

      try {
        taggedRentalLineKey = await tagRentalCartLine(originalFetch, bundleKey, addResponseBody);
        if (!taggedRentalLineKey) {
          pushDataLayer('order_ahead_rental_tag_missing', {
            bundleKey
          });
          bridgeLog('rental_tag_missing_continue', {
            bundleKey
          });
        }

        bridgeLog('supplemental_request', {
          attempt: 1,
          url: '/cart/add.js?wificandy_supplemental'
        });
        const supplementalResponse = await originalFetch('/cart/add.js?wificandy_supplemental', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: supplementalItems })
        });

        const supplementalBody = await supplementalResponse.clone().text();
        bridgeLog('supplemental_response', {
          attempt: 1,
          ok: supplementalResponse.ok,
          status: supplementalResponse.status,
          body: supplementalBody
        });

        if (!supplementalResponse.ok) {
          throw new Error(`supplemental_add_failed_${supplementalResponse.status}`);
        }

        disarmReserveBridge();
        setOrderAheadCartHint(false);
        pushDataLayer('order_ahead_cart_redirect', {
          pickup: state.pickupKey,
          return: state.returnKey,
          powercandy: state.addonSelected
        });
        bridgeLog('redirect_cart_after_success', { target: '/cart' });
        window.location.assign('/cart');
        return;
      } catch (error) {
        lastError = error;
        bridgeLog('supplemental_error', {
          attempt: 1,
          message: error && error.message ? error.message : 'unknown_error'
        });
      }

      disarmReserveBridge();
      setOrderAheadCartHint(true);
      pushDataLayer('order_ahead_supplemental_add_failed', {
        message: lastError && lastError.message ? lastError.message : 'unknown_error'
      });
      bridgeLog('redirect_cart_after_failure', {
        target: '/cart',
        message: lastError && lastError.message ? lastError.message : 'unknown_error'
      });
      try {
        if (!taggedRentalLineKey) {
          await tagRentalCartLine(originalFetch, bundleKey, addResponseBody);
        }
      } catch (_error) {
        bridgeLog('rental_tag_failure_recovery_skipped');
      }
      window.location.assign('/cart');
    }

    function ensureRecapObserver() {
      const recapNode = root.querySelector('#izyRecap');
      if (!recapNode || recapNode === observedRecapNode) {
        return Boolean(recapNode);
      }
      observedRecapNode = recapNode;
      if (recapObserver) {
        recapObserver.disconnect();
      }
      recapObserver = new MutationObserver(() => {
        syncRentalStateFromRecapNode();
        renderOptions();
        renderSummary();
      });
      recapObserver.observe(recapNode, {
        childList: true,
        subtree: true,
        characterData: true
      });
      syncRentalStateFromRecapNode();
      return true;
    }

    if (addonCheckbox && !powercandy.variantId) {
      void ensurePowercandyConfig();
    }

    syncAddonUi();

    pickupList.addEventListener('change', (event) => {
      if (!event.target || typeof event.target.value !== 'string') return;
      state.pickupKey = event.target.value;
      state.returnKey = '';
      renderOptions();
      renderSummary();
      setActiveStep('return', { scrollAfterExpand: true });
    });

    returnList.addEventListener('change', (event) => {
      if (!event.target || typeof event.target.value !== 'string' || !state.pickupKey) return;
      state.returnKey = event.target.value;
      renderOptions();
      renderSummary();
      closeReturnPanel();
    });

    if (addonCheckbox) {
      addonCheckbox.addEventListener('change', () => {
        state.addonSelected = addonCheckbox.checked;
        syncAddonUi();
        renderSummary();
      });
    }

    STEPS.forEach((step) => {
      const head = stepHeads[step];
      if (!head) return;
      head.addEventListener('click', (event) => {
        if (head.disabled) return;
        if (!isStepAccessible(step)) return;
        event.preventDefault();
        setActiveStep(step, { scrollIntoView: false, focusFirstInput: step !== 'dates' });
        if (step === 'dates') {
          const firstDateField = datesStage
            ? datesStage.querySelector('input:not([type="hidden"]):not([disabled]), button:not([disabled]):not([data-add-to-cart]), [tabindex]:not([tabindex="-1"])')
            : null;
          if (firstDateField && typeof firstDateField.focus === 'function') {
            try {
              firstDateField.focus({ preventScroll: true });
            } catch (_error) {
              firstDateField.focus();
            }
          }
        }
      });
    });

    document.addEventListener('izyrentCheckDate', (event) => {
      syncRentalStateFromEvent(event);
      window.requestAnimationFrame(() => {
        syncRentalStateFromRecapNode();
        const hasDates = logic.hasSelectedRentalDates(state.rentalLabel);
        if (hasDates) {
          cancelPendingDatesReset();
          syncPickupSelectionsToCurrentDates();
        } else {
          scheduleLogisticsResetIfDatesStayEmpty();
        }
        renderOptions();
        renderSummary();
        if (
          state.activeStep === 'dates' &&
          state.pickupKey &&
          state.returnKey &&
          logic.hasSelectedRentalDates(state.rentalLabel)
        ) {
          state.activeStep = '';
          applyStepStates();
          scrollFocusToSummaryOnMobile();
        }
      });
    });

    let rootObserver = null;
    if (datesStage && !ensureRecapObserver()) {
      rootObserver = new MutationObserver(() => {
        if (ensureRecapObserver()) {
          renderOptions();
          renderSummary();
          rootObserver.disconnect();
        }
      });
      rootObserver.observe(datesStage, { childList: true, subtree: true });
    }

    const orderAheadBridge = root.__wifiCandyOrderAheadBridge || {
      matches(requestUrl) {
        return (
          state.reserveBridgeArmed &&
          logic.shouldHandleIzyRentCartAdd({
            pendingRedirectUntil: Number.MAX_SAFE_INTEGER,
            now: Date.now(),
            requestUrl
          })
        );
      },
      async handleSuccess(originalFetch, requestMeta, requestUrl, responseContext) {
        bridgeLog('izyrent_add_intercepted', {
          via: requestMeta.via,
          requestUrl,
          armed: state.reserveBridgeArmed
        });
        await appendSupplementalItems(
          getInternalCartFetch(originalFetch),
          responseContext && responseContext.addResponseBody
        );
      },
      handleFailure(requestMeta, requestUrl, status, message) {
        handleIzyRentAddFailure({
          via: requestMeta.via,
          requestUrl,
          status,
          message
        });
      },
      logIgnored(requestMeta, requestUrl) {
        bridgeLog('izyrent_add_ignored', {
          via: requestMeta.via,
          requestUrl,
          armed: state.reserveBridgeArmed,
          pendingRedirectUntil: state.pendingRedirectUntil,
          now: Date.now()
        });
      }
    };
    root.__wifiCandyOrderAheadBridge = orderAheadBridge;
    window.__wifiCandyOrderAheadBridges = window.__wifiCandyOrderAheadBridges || [];
    if (!window.__wifiCandyOrderAheadBridges.includes(orderAheadBridge)) {
      window.__wifiCandyOrderAheadBridges.push(orderAheadBridge);
    }

    if (!window.__wifiCandyOrderAheadFetchWrapped) {
      const originalFetch = window.fetch.bind(window);

      window.fetch = async function wrappedOrderAheadFetch() {
        const args = Array.from(arguments);
        const requestMeta = resolveRequestMeta(args[0]);
        const requestUrl = requestMeta.requestUrl;
        const activeBridge = (window.__wifiCandyOrderAheadBridges || []).find((bridge) => bridge.matches(requestUrl));
        const isPreparationRequest = isArmedIzyRentPreparationRequest(requestUrl);
        let response;

        try {
          response = await originalFetch.apply(window, args);
        } catch (error) {
          if (activeBridge) {
            activeBridge.handleFailure(
              requestMeta,
              requestUrl,
              0,
              error && error.message ? error.message : 'network_error'
            );
          } else if (isPreparationRequest) {
            handleIzyRentAddFailure({
              via: requestMeta.via,
              requestUrl,
              status: 0,
              message: error && error.message ? error.message : 'izyrent_prepare_request_failed'
            });
          }
          throw error;
        }

        if (requestUrl.includes('/cart/add')) {
          bridgeLog('fetch_resolved', {
            via: requestMeta.via,
            requestUrl,
            ok: response.ok,
            status: response.status
          });
        }

        if (activeBridge && response.ok) {
          const addResponseBody = await parseJsonResponseBody(response);
          await activeBridge.handleSuccess(originalFetch, requestMeta, requestUrl, {
            addResponseBody
          });
        } else if (activeBridge) {
          activeBridge.handleFailure(requestMeta, requestUrl, response.status, `izyrent_add_failed_${response.status}`);
        } else if (isPreparationRequest && !response.ok) {
          handleIzyRentAddFailure({
            via: requestMeta.via,
            requestUrl,
            status: response.status,
            message: `izyrent_prepare_failed_${response.status}`
          });
        } else if (requestUrl.includes('/cart/add.js?izyrent')) {
          (window.__wifiCandyOrderAheadBridges || []).forEach((bridge) => {
            if (typeof bridge.logIgnored === 'function') {
              bridge.logIgnored(requestMeta, requestUrl);
            }
          });
        }

        return response;
      };

      window.__wifiCandyOrderAheadFetchWrapped = true;
    }

    async function triggerReserve() {
      if (state.reserveBridgeArmed || cartPreflightPending || !nativeAddToCartButton) return;

      state.reserveError = '';

      if (!logic.hasSelectedRentalDates(state.rentalLabel)) {
        setActiveStep('dates', { scrollAfterExpand: true });
        setAttentionStep('dates');
        updateReserveState();
        bridgeLog('reserve_blocked_missing_dates');
        pushDataLayer('order_ahead_dates_missing');
        return;
      }

      if (!logic.hasSelectedLogistics({
        pickupKey: state.pickupKey,
        returnKey: state.returnKey
      })) {
        const missingStep = logic.getMissingLogisticsStep({
          pickupKey: state.pickupKey,
          returnKey: state.returnKey
        }) || 'pickup';
        setActiveStep(missingStep, { scrollAfterExpand: true, focusFirstInput: true });
        setAttentionStep(missingStep);
        updateReserveState();
        bridgeLog('reserve_blocked_missing_logistics', {
          pickup: state.pickupKey,
          return: state.returnKey
        });
        pushDataLayer('order_ahead_logistics_missing', {
          pickup: state.pickupKey,
          return: state.returnKey
        });
        return;
      }

      if (!logic.isReservationReady({
        rentalLabel: state.rentalLabel,
        rentalCents: state.rentalCents,
        pickupKey: state.pickupKey,
        returnKey: state.returnKey
      })) {
        updateReserveState();
        bridgeLog('reserve_blocked_unresolved_total', {
          rentalCents: state.rentalCents,
          rentalLabel: state.rentalLabel,
          pickup: state.pickupKey,
          return: state.returnKey
        });
        pushDataLayer('order_ahead_total_unresolved', {
          rentalCents: state.rentalCents,
          rentalLabel: state.rentalLabel
        });
        return;
      }

      const pickupAvailability = logic.getPickupAvailability({
        pickupKey: state.pickupKey,
        rentalStartDate: state.rentalStartDate,
        now: new Date()
      });

      if (!pickupAvailability.isAvailable) {
        clearPickupAndReturnSelections();
        renderOptions();
        renderSummary();
        setActiveStep('pickup', { scrollAfterExpand: true, focusFirstInput: true });
        setAttentionStep('pickup');
        bridgeLog('reserve_blocked_pickup_lead_time', {
          rentalStartDate: state.rentalStartDate,
          leadDays: pickupAvailability.leadDays
        });
        pushDataLayer('order_ahead_pickup_lead_time_blocked', {
          leadDays: pickupAvailability.leadDays
        });
        return;
      }

      state.addonSelected = Boolean(addonCheckbox && addonCheckbox.checked);

      if (state.addonSelected && !powercandy.variantId) {
        await ensurePowercandyConfig();
        if (!powercandy.variantId) {
          state.addonSelected = false;
          if (addonCheckbox) {
            addonCheckbox.checked = false;
          }
          syncAddonUi();
          renderSummary();
          bridgeLog('powercandy_unavailable_for_reserve');
          pushDataLayer('order_ahead_powercandy_unavailable');
          if (typeof window.alert === 'function') {
            window.alert('Powercandy is temporarily unavailable. Please try again or continue without it.');
          }
          return;
        }
      }

      if (!isNativeAddToCartReady()) {
        requestIzyRentRefresh('native_add_not_ready');
        updateReserveState();
        return;
      }

      cartPreflightPending = true;
      let canContinue = false;
      try {
        canContinue = await ensureEmptyCartOrPrompt(
          getInternalCartFetch(window.fetch.bind(window))
        );
      } catch (error) {
        state.reserveError = RESERVE_ADD_FAILURE_MESSAGE;
        updateReserveState();
        bridgeLog('cart_preflight_failed', {
          message: error && error.message ? error.message : 'unknown_error'
        });
      } finally {
        cartPreflightPending = false;
      }
      if (!canContinue) {
        return;
      }

      state.activeBundleKey = `bundle_${Date.now()}`;
      setOrderAheadCartHint(false);
      armReserveBridge();
      if (state.historyRestoredSinceLastReserve) {
        pushDataLayer('order_ahead_repeat_reserve_after_history_restore', {
          pickup: state.pickupKey,
          return: state.returnKey,
          rentalLabel: state.rentalLabel
        });
        state.historyRestoredSinceLastReserve = false;
      }
      bridgeLog('reserve_click', {
        pickup: state.pickupKey,
        return: state.returnKey,
        addonSelected: state.addonSelected,
        rentalCents: state.rentalCents,
        bundleKey: state.activeBundleKey,
        pendingRedirectUntil: state.pendingRedirectUntil
      });
      pushDataLayer('order_ahead_reserve_click', {
        pickup: state.pickupKey,
        return: state.returnKey,
        powercandy: state.addonSelected,
        rentalCents: state.rentalCents,
        rentalLabel: state.rentalLabel
      });
      nativeAddToCartButton.click();
    }

    reserveButton.addEventListener('click', (event) => {
      event.preventDefault();
      void triggerReserve();
    });

    if (floorReserve) {
      floorReserve.addEventListener('click', (event) => {
        event.preventDefault();
        void triggerReserve();
      });
    }

    if (nativeProductForm) {
      // Keep Enter/implicit form submits on the guided reserve path until the bridge is armed.
      nativeProductForm.addEventListener('submit', (event) => {
        if (state.reserveBridgeArmed) {
          return;
        }

        event.preventDefault();
        void triggerReserve();
      });
    }

    if (typeof window.addEventListener === 'function') {
      window.addEventListener('pagehide', () => {
        if (!state.reserveBridgeArmed) {
          return;
        }

        bridgeLog('reserve_bridge_pagehide_reset');
        disarmReserveBridge();
      });

      window.addEventListener('pageshow', (event) => {
        if (!event || !event.persisted) {
          return;
        }

        bridgeLog('reserve_bridge_pageshow_restore');
        disarmReserveBridge();
        state.historyRestoredSinceLastReserve = true;
        state.reserveError = '';
        requestIzyRentRefresh('pageshow_restore');
        syncRentalStateFromRecapNode();
        renderOptions();
        renderSummary();
      });
    }

    setActiveStep('dates');
    state.hasUserSelectedStep = false;
    renderOptions();
    ensureRecapObserver();
    syncRentalStateFromRecapNode();
    renderOptions();
    renderSummary();
  }

  function init() {
    document.querySelectorAll('[data-order-ahead-root]').forEach(initOrderAhead);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
